import { termini_it } from '#nuxt-prepare'

export default defineI18nLocale(async (locale) => {
    return termini_it
})